import SeparatorLine from "app/components/ui/Separator/SeparatorLine";
import "./PriceSummary.scss";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import PaymentDueSummaryContainer from "app/pages/Booking/Quotation/PriceDetails/PaymentDueSummary/PaymentDueSummaryContainer";
import { QuotationPriceDetailContainer } from "app/pages/Booking/Quotation/PriceDetails/QuotationPriceDetailContainer.jsx";
import "./PriceSummary.scss";
import { useContext } from "react";
import AppGlobalsContext from "app/AppGlobalsContext";

const PaymentPriceSummary = () => {
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL;

	return (
		<>
			{isMobile && (
				<div className="price-summary price-summary--payment">
					<QuotationPriceDetailContainer />

					<SeparatorLine />
				</div>
			)}

			<PaymentDueSummaryContainer />
		</>
	);
};

export default PaymentPriceSummary;
